import { cn } from '@/lib/utils'
import { Badge } from '@/components/ui/badge'

/** Uniform value badge — same color for all values */
export function TagValueBadge({ value, className }: { value: string; className?: string }) {
  return (
    <Badge variant="secondary" className={cn('text-xs font-normal', className)}>
      {value}
    </Badge>
  )
}
